import { getCookie } from "../../helper/cookie";
import { trackEvent, trackPageMeta } from '@farmnet/tag-manager';

registrationController.$inject = [
  '$scope',
  '$rootScope',
  '$http',
  'i18nFilter',
  '$timeout',
  '$anchorScroll',
  '$location',
  'system-config.constant',
  'languageService',
  'CountryService',
  'selfRegistrationResolverResult',
  'LoginService',
  'tracker',
];

export function registrationController(
  $scope,
  $rootScope,
  $http,
  i18nFilter,
  $timeout,
  $anchorScroll,
  $location,
  systemConfig,
  languageService,
  CountryService,
  selfRegistrationResolverResult,
  LoginService,
  tracker,
) {
  var controller = this;
  var sysCountries = selfRegistrationResolverResult.sysCountries;
  var LAST_ROUTE_PARAMETER = 'lastRoute';

  // functions
  controller.register = register;
  controller.getSelectedCountry = getSelectedCountry;
  $scope.suggestUsername = suggestUsername;
  $scope.promoChanged = promoChanged;
  $scope.hasError = hasError;
  $scope.isEmailNotConfirmed = isEmailNotConfirmed;
  $scope.changeInfo = changeInfo;
  $scope.changeLanguage = changeLanguage;
  $scope.userPattern = /^[A-Za-z0-9\-\_\.@]{4,50}$/;
  $scope.passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S ]{6,}$/;
  $scope.emailPattern = /[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

  // properties
  controller.formElementsInvalid = [];
  controller.disableForm = true;
  controller.currentInputName = undefined;
  controller.registered = false;
  controller.userExist = false;
  controller.submitted = false;
  controller.promocodeUsed = false;
  controller.promocodeNonExistant = false;
  controller.userNameExists = false;
  controller.permissionToBeContacted = false;
  controller.countryNotChosen = false;
  controller.staticDocumentPrivacyPolicy = '';
  controller.staticDocumentTOS = '';
  controller.showPromoCodeInput = false;
  controller.form = {};
  controller.info = undefined;
  controller.userNameIsDirty = undefined;
  controller.buttonDisabled = false;
  controller.countries = CountryService.sortCountries(sysCountries);
  controller.form = selfRegistrationResolverResult.regForm;
  controller.isSubmitButtonDisabled = false;

  postInit();

  // sticky registration footer
  angular.element('.contentPane').css('min-height', 'calc(100% - 64px)');

  // PostInit function - which is called later - is needed because extraction of resolver result values takes place asynchronously
  function postInit() {
    // Guess country and select in form
    // TODO: rewrite that service, need a reason? switch this line with line 41 and see the flaw working
    controller.form.country = languageService.guessCountry();
    // Select detected language in form
    controller.form.language = languageService.getPrimaryLanguage();

    // apply detected language
    $scope.changeLanguage(true);
    controller.info = i18nFilter(
      'fe.register.info.' + controller.form.country
    );

    // set landsberg registration key and registration data into registration form in case of landsberg registration
    // the key will link the company with the landsberg account
    const landsbergRegistrationKeyParam = $location.search().landsbergRegistrationKey;
    if (landsbergRegistrationKeyParam) {
      controller.form.props.landsbergRegistrationKey = landsbergRegistrationKeyParam;

      const landsbergRegistrationData = getCookie('landsbergRegistration');
      if (landsbergRegistrationData) {
        const decodedString = decodeURIComponent(escape(atob(landsbergRegistrationData)));
        const splittedData = decodedString.split(',');
        const landsbergRegistrationDataMap = {};
        for (var i=0; i<splittedData.length; i++) {
          const registrationDataEntry = splittedData[i].split('=');
          landsbergRegistrationDataMap[registrationDataEntry[0]] = registrationDataEntry[1];
        }
        controller.form.firstName = landsbergRegistrationDataMap['firstName'];
        controller.form.lastName = landsbergRegistrationDataMap['lastName'];
        controller.form.email = landsbergRegistrationDataMap['email'];
        controller.form.zipCode = landsbergRegistrationDataMap['zipCode'];
      }

      // delete cookie
      document.cookie = 'landsbergRegistration=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }

    $timeout(function() {
      $('#farmName').focus();
      $('input:text')
        .first()
        .focus()
        .select();
    });
  }

  function addUnknownCountry(countries) {
    countries.unshift({
      orderKey: '*',
      isoCode: 'UKN',
      translation: i18nFilter('fe.register.pleasechooseacountry'),
      shopCountry: false
    });
  }

  // set up language
  function changeLanguage(doNotSetCountriesObj) {
    app.showLoader();
    languageService
      .setLanguage(controller.form.language, true)
      .then(function() {
        // [{isoCode: 'DEU', translation: 'Germany'}, ...]
        if (!doNotSetCountriesObj)
          controller.countries = CountryService.sortCountries(sysCountries);

        // strangely injecting an item if no country was identified
        addUnknownCountry(controller.countries);

        // Set combo box again as long as languages have to be translated
        // { 'en': 'English', ... }
        // CFNPOC-10405 changed behavior
        controller.languages = languageService.getSupportedPrimaryLanguagesNativeArray();
        controller.info = i18nFilter(
          'fe.register.info.' + controller.form.country
        );

        // less impact than another $watch
        controller.staticDocumentsTermsOfService = systemConfig.staticDocumentsURL +
          systemConfig.staticDocumentsTermsOfService.replace('{0}',controller.form.language);
        controller.staticDocumentTOS = i18nFilter(
          'fe.register.dataprotectionagreement.link',
          'https://www.365farmnet.com/de/datenschutz/'
        );

        // privacy policy
        controller.staticDocumentPrivacyPolicy = systemConfig.staticDocumentsURL +
          systemConfig.staticDocumentsPrivacyPolicy.replace('{0}',controller.form.language.toUpperCase());

        $scope.changeInfo();

        app.hideLoader();
      });
  }

  function changeInfo() {
    // TODO: filter shop countries
    // if (controller.getSelectedCountry()) {
    //   // NOTE: `showPromoCodeInput` is provisionally used to display the porsche
    //   // contest form group in shop countries. The porsche contest form group
    //   // will be removed in a v23.1 hotfix.
    //   controller.showPromoCodeInput = controller.getSelectedCountry().shopCountry;
    // } else {
    //   controller.showPromoCodeInput = false;
    // }
    controller.info = i18nFilter(
      'fe.register.info.' + controller.form.country
    );
  }

  // Checks if the field failed (optionally on a specific) validation
  // Used to show/hide error messages
  function hasError(field, validation) {
    if (!$scope.register[field]) {
      return;
    }
    if (validation)
      return (
        ($scope.register[field].$dirty || $scope.submitted) &&
        $scope.register[field].$error[validation]
      );
    else
      return (
        ($scope.register[field].$dirty || $scope.submitted) &&
        $scope.register[field].$invalid
      );
  }

  function isEmailNotConfirmed() {
    return $scope.register.$submitted && controller.form.email !== controller.form.confirmEmail;
  }

  // promocodes
  function promoChanged() {
    controller.promocodeUsed = false;
    controller.promocodeNonExistant = false;
  }

  // suggest user name
  function suggestUsername(event) {
    if (
      event === null ||
      event === undefined ||
      controller.form.email === undefined
    ) {
      return;
    }

    switch (event.currentTarget.id) {
      case 'email': {
        if (!controller.userNameIsDirty) {
          controller.form.username = controller.form.email;
        }
        break;
      }
      case 'username': {
        if (controller.form.username !== '') {
          controller.userNameIsDirty = true;
        }
        break;
      }
      default:
        break;
    }
  }

  // get the selected country
  function getSelectedCountry(isoCode) {
    var selectedCountry;
    angular.forEach(controller.countries, function(item, key) {
      if (
        item.isoCode !== 'UKN' &&
        item.isoCode === controller.form.country
      ) {
        selectedCountry = item;
        return;
      }
    });
    return selectedCountry;
  }

  function getLastRoute() {
    const params = new URLSearchParams(location.search);
    return params.get(LAST_ROUTE_PARAMETER);
  }

  function login(username, password) {

    app.showLoader();
    LoginService.authenticate({ username, password })
      .then(
      function(creds) {
        app.hideLoader();
        creds = creds || {};

        controller.loginAlert = undefined;
        app.credentials = $rootScope.credentials = creds;
        controller.accountIsLocked = creds.isLocked;
        if ($rootScope.credentials.loggedIn) {
          tracker.trackEvent('LOGIN', 'logged in');

          if (controller.form.props.landsbergRegistrationKey) {
            window.location = `/genericFarmMap/PrecisionFarming`;
          } else {
            window.location.href = 'index.html';
          }
        } else {
          controller.loginAlert = true;
          $scope.password = '';
        }
      },
      function() {
        app.hideLoader();
        controller.loginAlert = true;
      }
    );

    return false;
  }

  // Registration processing
  function register() {
    $scope.submitted = true; // Show error messages

    // for whatever reason the select never gets invalid even if nothing valid was selected
    if (!controller.getSelectedCountry(controller.form.country)) {
      $scope.register.country.$setValidity('required', false);
      controller.isSubmitButtonDisabled = false;
      return;
    }

    if (!$scope.register.$invalid) {
      controller.buttonDisabled = true;

      app.showLoader();

      // Reset error flags
      controller.promocodeUsed = false;
      controller.promocodeNonExistant = false;
      controller.userNameExists = false;
      controller.countryNotChosen = false;

      // validate that both email addressed match each other
      if (isEmailNotConfirmed()) {
        app.hideLoader();
        controller.buttonDisabled = false;
        controller.isSubmitButtonDisabled = false;
        return;
      }

      // TODO: refactor to service
      $http
        .put('/365FarmNet/mod/registration/rest/v1.0/public', controller.form)
        .then(
          // Successful
          function(httpResponse) {
            app.hideLoader();

            const registrationResult = httpResponse.data;

            // track gtm registration event
            trackEvent(
              'Customer Relations',
              'Account Registration',
              'Single Opt-In'
            );

            // track gtm page meta
            trackPageMeta(
              {
                uiNewsletterSubscriber: controller.form.permissionToBeContacted.toString(), // only during login and account registration
                uiCustomerType: 'active' // only during login
              }
            );

            if ((registrationResult && registrationResult.resultStatus === 'success')
              || (registrationResult && registrationResult.resultStatus === 'obsolete')) {

              // direct login after registration
              login(controller.form.username, controller.form.password);
            } else {
              // The route change takes time, during which
              // the submit button should stay disabled
              controller.isSubmitButtonDisabled = true;
              window.location = 'index.html#/error/regFailed';
            }
          },
          // Error, registration failed
          function(httpResponse) {
            const registrationResult = httpResponse.rejection.data;

            app.hideLoader();
            controller.buttonDisabled = false;
            controller.isSubmitButtonDisabled = false;

            switch (registrationResult.resultStatus) {
              case 'promocodeUsed':
                controller.promocodeUsed = true;
                break;
              case 'promocodeNonExistant':
                controller.promocodeNonExistant = true;
                break;
              case 'promocodeNotAllowed':
                controller.promocodeNotAllowed = true;
                break;
              case 'mustAgreeToTerms':
                controller.form.termsAccepted = false;
                break;
              case 'userexist':
                controller.userNameExists = true;
                break;
              default:
                // The route change takes time, during which
                // the submit button should stay disabled
                controller.isSubmitButtonDisabled = true;
                window.location = 'index.html#/error/regFailed';
                break;
            }
          }
        );

      return false;
    }

    controller.isSubmitButtonDisabled = false;
  }
}
